(function () {
  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
      return;
    }
    fn();
  }

  onReady(function () {
    // Safety watchdog: if visualiser JS is slow or fails to load, fall back
    // to a static, non-interactive preview instead of a stuck loading state.
    window.setTimeout(function () {
      var roots = document.querySelectorAll(
        '[data-feature="visualiser-v3-mobile"] .pdpv3m-root, [data-feature="visualiser-v3-desktop"] .pdpv3d-root'
      );
      Array.prototype.forEach.call(roots, function (root) {
        if (!root) return;
        var mobileReady = root.getAttribute('data-mobile-visualiser-ready') === 'true';
        var desktopReady = root.getAttribute('data-desktop-visualiser-ready') === 'true';
        if (mobileReady || desktopReady) return;

        root.classList.add('pdpv3-fallback-ready');
        var scrim = root.querySelector('[data-pdpv3m-loading-scrim]');
        if (scrim && scrim.style) {
          scrim.style.display = 'none';
        }
      });
    }, 4200);
  });
})();
